import Vue from 'vue'
import Router from 'vue-router'
import main from '@/page/main'
import userRouter from './user'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


const router =  new Router({
    mode: 'history',
    base: '',
    routes: [
        {
            path: '',
            component: r => require.ensure([], () => r(require('../page/main')), 'main'),
            children:[
                {
                    path: '',
                    name: 'index',
                    component: r => require.ensure([], () => r(require('../page/index')), 'index')
                },
                {
                    path: '/room/:id',
                    name: 'roomDetail',
                    component: r => require.ensure([], () => r(require('../page/room/detail')), 'roomDetail')
                },
                {
                    path: '/date/:id/:type',
                    name: 'date',
                    component: r => require.ensure([], () => r(require('../page/room/date')), 'date')
                },
                {
                    path: '/time/:id/:date/:type',
                    name: 'time',
                    component: r => require.ensure([], () => r(require('../page/room/time')), 'time')
                },
                {
                    path: '/pay/purpose',
                    name: 'purpose',
                    component: r => require.ensure([], () => r(require('../page/room/purpose')), 'purpose')
                },
                {
                    path: '/login',
                    name: 'login',
                    component: r => require.ensure([], () => r(require('../page/login/login')), 'login'),
                },
                {
                    path: '/initLogin',
                    name: 'initLogin',
                    component: r => require.ensure([], () => r(require('../page/login/initLogin')), 'initLogin'),
                },
                {
                    path: '/roomOrder',
                    name: 'roomOrder',
                    component: r => require.ensure([], () => r(require('../page/roomOrder')), 'roomOrder'),
                },
                ...userRouter.routes,
            ],
            beforeEnter(to,form,next){
				
               
                if(localStorage.getItem('userMobile')=='-1' && to.name!=='initLogin' && to.name!=='index' && to.name!=='login' && to.name!=='bindMobile'){
                    next({
                        name: 'bindMobile',
                        query: {
                            gourl: to.fullPath
                        }
                    });
                }else{
                    /*路由变化修改title*/
                    if(to.meta.title){
                        document.title=to.meta.title
                    }
                    next();
                }
            }
        }  
    ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js